import React, {Component} from "react";
import {withPixiApp} from "@inlet/react-pixi";
import withAutoplayConfiguration from "../../core/components/autoplay/configuration/withAutoplayConfiguration";

import * as PIXI from "pixi.js";
import {connect} from "react-redux";
import {Dispatch} from "redux";


import {actions as baseGameActions} from "../../core/reducers/baseGameReducer";
import {Button} from "react-bootstrap";
import {MDBBtn, MDBCol, MDBTable, MDBTableBody, MDBContainer, MDBRow} from "mdbreact";
import {actions as winPresentationAction} from "../../core/reducers/winPresentationReducer";
import {actions as reelsActions} from "../../core/reducers/reelsStateReducer";
import {actions as gridsActions} from "../../core/reducers/gridStateReducer";
import {actions as reelGridActions} from "../../core/reducers/reelgridStateReducer";

import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import Toggle from 'react-toggle';
import "react-toggle/style.css";
import {isMobile} from "react-device-detect";
import {actions as buttonActions} from "../../core/reducers/buttonPanelReducer";
import {actions as autoplayActions} from "../../core/reducers/autoplayReducer";
import {actions as asyncActions} from "../../core/reducers/asyncServerResponseReducer";
import {
    configGame
} from "../../data/config";
import {actions as behaviourAction} from "../../gamereducer/behaviourReducer";

interface IProps {
    [x: string]: any;
}

interface IState {

}
interface IStore {
    [x: string]: any;
}
interface IState {
    isGameLoaded: boolean,
    enableOk: boolean,
    width: number | string,
    height: number | string,
    pixelRatio: number,
    buttonSelected: any,
    selectedAutoplayCount: number,
    toggleOn: boolean,
    valueOfFirstSlider: number,
    valueOfSecondSlider: number,
    valueOfThirdSlider: number,

}

interface IStateToProps {
}

interface IDispatchToProps {
}

class AutoplayGenericUI extends Component<IProps, IState> {
    protected app: PIXI.Application;

    protected autoplayGenericUIContainer: any;
    protected scope: any;
    protected showFixedPanelPage: boolean;
    protected outerBorderColor: any;
    protected textColor: any;
    protected colorOfButtonsWithoutCLick: any;
    protected colorOfButtonsOnCLick: any;
    protected mainContainerBgColor: any;
    protected partitioningLineBorderColor: any;
    protected clickedNumberButton: any;
    protected unClickedNumberButton: any;
    protected startbutton: any;
    protected enableAutoplayStartButtonX: number;
    protected enableAutoplayStartButtonY: number;
    protected disableAutoplayStartButtonX: number;
    protected disableAutoplayStartButtonY: number;
    protected valueMultiplierForFirstSlide: number = 500;
    protected valueMultiplierForSecondSlide: number = 5000;
    protected heightOfTable: string = '300px';
    protected buttonTextColor: string = 'white';
    protected resolutionPath: any;
    private minFullHDWidth: number = 1024;
    private HDReadyWidth: number = 1280;
    private fullHDWidth: number = 1920;
    private minFullHDPxRatio: number = 2;
    private multiplierOfFirstSlide: number = 500;
    private multiplierOfSecondSlide: number = 5000;

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.autoplayGenericUIContainer = React.createRef();
        this.state = {
            width: this.props.width,
            height: this.props.height,
            buttonSelected: "",
            selectedAutoplayCount: 0,
            pixelRatio: 1,
            enableOk: false,
            isGameLoaded: false,
            toggleOn: true,
            valueOfFirstSlider: 0,
            valueOfSecondSlider: 0,
            valueOfThirdSlider: 0,
        }
        this.showFixedPanelPage = false;
        this.outerBorderColor = '#FFFFFF';
        this.textColor = '#f5f3ec';
        this.colorOfButtonsWithoutCLick = '#808080';
        this.colorOfButtonsOnCLick = '#008000';
        this.mainContainerBgColor = 'transparent';
        this.partitioningLineBorderColor = '#808080';

        this.enableAutoplayStartButtonX = -1;
        this.enableAutoplayStartButtonY = -63;
        this.disableAutoplayStartButtonX = -1;
        this.disableAutoplayStartButtonY = -1;
        let screen = window.screen

        let isFullHD = false;
        // FullHD atlas will be loaded on devices whose base resolution is greater than 1024px width and its pixel ratio (density) is greater than 1 (https://mydevice.io/devices/)
        // In the case of computer screens which normally have a pixel ratio of 1, it will be checked if the base resolution is HDReady or FullHD to load the fullHD atlas
        if (((screen.width >= this.minFullHDWidth || screen.height >= this.minFullHDWidth) && window.devicePixelRatio >= this.minFullHDPxRatio) ||
            (screen.width >= this.HDReadyWidth || screen.height >= this.HDReadyWidth)) {
            isFullHD = true;
        }
        if (isFullHD) {
            this.resolutionPath = "HD/";
        } else {
            this.resolutionPath = "LD/";
        }
        this.clickedNumberButton = this.resolutionPath + this.props.data.clickedNumberButton;
        this.unClickedNumberButton = this.resolutionPath + this.props.data.unclickedNumberButton;
    }


    //this method will reset all the values
    reset() {
        this.props.setValueOfNumberButton(0)
        this.setState((prevState) => {
            return {
                ...prevState,
                buttonSelected: "",
                enableOk: false,

            }
        })
    }


    //this method will be called when a button gets clicked
    onClick(name: any, value: any) {
        this.props.setValueOfNumberButton(value - 1)
        this.props.interactivityOfStartButton(true)
        this.setState((prevState) => {
            return {
                ...prevState,
                selectedAutoplayCount: value - 1,
                buttonSelected: name,
                enableOk: true,
            }
        })
    }

//this method is for update the dimensions according to the screen size
    updateDimensions = () => {
        this.setState((prevState) => {
            return {
                ...prevState,
                width: isMobile && window.screen.availWidth || window.innerWidth,
                height: isMobile && window.screen.availHeight || window.innerHeight,
                pixelRatio: window.devicePixelRatio
            }
        })
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
        this.updateDimensions();

    }


    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }


    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (nextProps.resetAutoplay && nextProps.resetAutoplay !== this.props.resetAutoplay) {
            this.reset();
        }
        if (nextProps.showAutoplay && nextProps.showAutoplay !== this.props.showAutoplay) {
            this.reset();
        }
        if (nextState.valueOfFirstSlider !== this.state.valueOfFirstSlider) {
            nextProps.setSingleWinExceed(Number(nextState.valueOfFirstSlider));
        }
        if (nextState.valueOfSecondSlider !== this.state.valueOfSecondSlider) {
            nextProps.setCashIncreasedBy(nextState.valueOfSecondSlider);
            nextProps.setBalanceIncreasedBy(Number(nextState.valueOfSecondSlider) + nextProps.balance);
        }
        if (nextState.valueOfThirdSlider !== this.state.valueOfThirdSlider) {
            nextProps.setBalanceDecreasedBy(nextState.valueOfThirdSlider);
            nextProps.setBalanceDecreasedBy(nextProps.balance - Number(nextState.valueOfThirdSlider));
        }
        return true;
    }

//this method will control toggle state
    toggleController = () => {
        this.setState((prevState) => {
            return {
                ...prevState,
                toggleOn: !this.state.toggleOn
            }
        })
    }


    //this method will show autoplay for mobile
    mobileViewAutoplay() {
        let maxLimitForFirstSlider, maxLimitForSecondSlider, maxLimitForThirdSlider:any;
        maxLimitForFirstSlider =  (this.props.betList[this.props.currentBetIndex])/100 * this.valueMultiplierForFirstSlide;
       
        maxLimitForSecondSlider = (this.props.betList[this.props.currentBetIndex])/100 * this.valueMultiplierForSecondSlide;
        maxLimitForThirdSlider = this.props.transitionBalance/100;
        parseFloat(maxLimitForThirdSlider);
        const {
            enableOk, selectedAutoplayCount, valueOfFirstSlider, valueOfSecondSlider, valueOfThirdSlider
        } = this.state;
        let startButtonX, startButtonY;
        if (enableOk) {
            startButtonX = this.enableAutoplayStartButtonX;
            startButtonY = this.enableAutoplayStartButtonY;
        } else {
            startButtonX = this.disableAutoplayStartButtonX;
            startButtonY = this.disableAutoplayStartButtonY;
        }
        return (
            <MDBTable className={"mainTableOfAutoplayPanel"} height={this.heightOfTable}>
                <MDBTableBody>
                    <tr>
                        <td colSpan={4} style={{border: "none"}}>
                            <MDBContainer style={{padding: '0px', margin: '0px'}}>
                                <MDBRow center={true}>
                                    <MDBCol className={"buttonContainer_1"} size="3" sm="3" lg="1">
                                        <MDBBtn className={"button1"}
                                                color={this.state.buttonSelected === "b1" ? "green" : "grey"}
                                                name={"b1"}
                                                onClick={() => this.onClick("b1", 5)}>
                                            {this.props.langObj["autoplayText_9"]}
                                        </MDBBtn>
                                    </MDBCol>
                                    <MDBCol size="3" sm="3" lg="1" className={"buttonContainer_2"}>
                                        <MDBBtn className={"button2"}
                                                color={this.state.buttonSelected === "b2" ? "green" : "grey"}
                                                name={"b2"}
                                                onClick={() => this.onClick("b2", 10)}>
                                            {this.props.langObj["autoplayText_10"]}
                                        </MDBBtn>
                                    </MDBCol>
                                    <MDBCol size="3" sm="3" lg="1" className={"buttonContainer_3"}>
                                        <MDBBtn className={"button3"}
                                                color={this.state.buttonSelected === "b3" ? "green" : "grey"}
                                                name={"b3"}
                                                onClick={() => this.onClick("b3", 15)}>
                                            {this.props.langObj["autoplayText_11"]}

                                        </MDBBtn>
                                    </MDBCol>
                                    <MDBCol size="3" sm="3" lg="1" className={"buttonContainer_4"}>
                                        <MDBBtn className={"button4"}
                                                color={this.state.buttonSelected === "b4" ? "green" : "grey"}
                                                name={"b4"}
                                                onClick={() => this.onClick("b4", 20)}>
                                            {this.props.langObj["autoplayText_12"]}

                                        </MDBBtn>
                                    </MDBCol>
                                    <MDBCol size="3" sm="3" lg="1" className={"buttonContainer_5"}>
                                        <MDBBtn className={"button5"}
                                                color={this.state.buttonSelected === "b5" ? "green" : "grey"}
                                                name={"b5"}
                                                onClick={() => this.onClick("b5", 30)}>
                                            {this.props.langObj["autoplayText_13"]}

                                        </MDBBtn>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow center={true} style={{marginTop: '10px'}}>
                                    <MDBCol size="3" sm="3" lg="1" className={"buttonContainer_6"}>
                                        <MDBBtn className={"button6"}
                                                color={this.state.buttonSelected === "b6" ? "green" : "grey"}
                                                name={"b6"}
                                                onClick={() => this.onClick("b6", 40)}>
                                            {this.props.langObj["autoplayText_14"]}

                                        </MDBBtn>
                                    </MDBCol>
                                    <MDBCol size="3" sm="3" lg="1" className={"buttonContainer_7"}>
                                        <MDBBtn className={"button7"}
                                                color={this.state.buttonSelected === "b7" ? "green" : "grey"}
                                                name={"b7"}
                                                onClick={() => this.onClick("b7", 50)}>
                                            {this.props.langObj["autoplayText_15"]}

                                        </MDBBtn>
                                    </MDBCol>
                                    <MDBCol size="3" sm="3" lg="1" className={"buttonContainer_8"}>
                                        <MDBBtn className={"button8"}
                                                color={this.state.buttonSelected === "b8" ? "green" : "grey"}
                                                name={"b8"}
                                                onClick={() => this.onClick("b8", 75)}>
                                            {this.props.langObj["autoplayText_16"]}

                                        </MDBBtn>
                                    </MDBCol>
                                    <MDBCol size="3" sm="3" lg="1" className={"buttonContainer_9"}>
                                        <MDBBtn className={"button9"}
                                                color={this.state.buttonSelected === "b9" ? "green" : "grey"}
                                                name={"b9"}
                                                onClick={() => this.onClick("b9", 100)}>
                                            {this.props.langObj["autoplayText_17"]}

                                        </MDBBtn>
                                    </MDBCol>

                                </MDBRow>
                            </MDBContainer>
                        </td>

                    </tr>
                </MDBTableBody>
                <MDBTableBody style={{border: "none"}}>
                    <tr>
                        <td style={{border: "none"}}>
                            <MDBContainer>
                                <MDBRow>
                                    <MDBCol xs="12"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <h2 className={"stopAutoplayText"}>{this.props.langObj["autoplayText_2"]}</h2>
                                    </MDBCol>
                                </MDBRow>

                                <MDBRow>
                                    <MDBCol size="5" sm="3"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <Toggle defaultChecked={this.props.stopAutoplayOnAnyWin} onChange={() => {
                                          
                                            this.props.stoppedAutoplayOnWin();
                                        }}/>
                                    </MDBCol>

                                    <MDBCol size="7" sm="4"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <h2 className={"onAnyWinText"}>{this.props.langObj["autoplayText_3"]}</h2>
                                    </MDBCol>
                                </MDBRow>
                            </MDBContainer>
                        </td>
                    </tr>
                </MDBTableBody>
                <MDBTableBody style={{border: "none"}}>
                    <tr>
                        <td style={{borderTop: "1px solid" + this.partitioningLineBorderColor}}>
                            <MDBContainer>
                                <MDBRow>
                                    <MDBCol size="8" sm="8"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <h2 className={"ifSingleWinExceedsByText"}>{this.props.langObj["autoplayText_6"]}</h2>
                                        <input type="range" className="custom-range " id="customRange1" min="0"
                                               max={maxLimitForFirstSlider}
                                               value={valueOfFirstSlider}
                                               onChange={() => {
                                                   let slider: any = document.getElementById("customRange1");
                                                   this.setState((prevState) => {
                                                       return {
                                                           ...prevState,
                                                           valueOfFirstSlider: slider.value
                                                       }
                                                   })
                                               }}/>
                                    </MDBCol>


                                    <MDBCol size="3" sm="3"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <h2 className={"ifSingleWinExceedsBySlider"}>{valueOfFirstSlider}</h2>
                                    </MDBCol>
                                </MDBRow>
                            </MDBContainer>
                        </td>
                    </tr>
                </MDBTableBody>
                <MDBTableBody style={{border: "none"}}>
                    <tr>
                        <td style={{border: "none"}}>
                            <MDBContainer>
                                <MDBRow>
                                    <MDBCol size="8" sm="8"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <h2 className={"balanceIncreasedByText"}>{this.props.langObj["autoplayText_7"]}</h2>
                                        <input type="range" className="custom-range " id="customRange2_M" min="0"
                                               max={maxLimitForSecondSlider}
                                               value={valueOfSecondSlider} onChange={() => {
                                            let slider: any = document.getElementById("customRange2_M");
                                            this.setState((prevState) => {
                                                return {
                                                    ...prevState,
                                                    valueOfSecondSlider: slider.value
                                                }
                                            })
                                        }}/>
                                    </MDBCol>

                                    <MDBCol size="3" sm="3"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <h2 className={"balanceIncreasedBySlider"}>{valueOfSecondSlider}</h2>
                                    </MDBCol>
                                </MDBRow>
                            </MDBContainer>
                        </td>
                    </tr>
                </MDBTableBody>
                <MDBTableBody style={{border: "none"}}>
                    <tr>
                        <td style={{border: "none"}}>
                            <MDBContainer>
                                <MDBRow>
                                    <MDBCol size="8" sm="8"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <h2 className={"balanceDecreasedByText"}>{this.props.langObj["autoplayText_8"]}</h2>
                                        <input type="range" className="custom-range " min="0"
                                               max={maxLimitForThirdSlider} id="customRange3_M"
                                               value={valueOfThirdSlider}
                                               onChange={() => {
                                                   let slider: any = document.getElementById("customRange3_M");
                                                   this.setState((prevState) => {
                                                       return {
                                                           ...prevState,
                                                           valueOfThirdSlider: slider.value
                                                       }
                                                   })
                                               }}/>
                                    </MDBCol>

                                    <MDBCol size="3" sm="3"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <h2 className={"balanceDecreasedBySlider"}>{valueOfThirdSlider}</h2>
                                    </MDBCol>
                                </MDBRow>
                            </MDBContainer>
                        </td>
                    </tr>
                </MDBTableBody>

                <MDBTableBody style={{border: "none"}}>
                    <tr>
                        <td style={{borderTop: "1px solid" + this.partitioningLineBorderColor}}>
                            {!this.showFixedPanelPage && <Button variant="danger" onClick={() => {
                                this.props.setAllButtonEnable();
                                this.props.hideAutoplay();
                                this.reset();
                            }}>{this.props.langObj["autoplayText_21"]}</Button>}

                            <button ref={i => this.startbutton = i} className="mobViewButtons" style={{

                                width: '260px',
                                height: '60px',
                                backgroundPositionX: startButtonX,
                                backgroundPositionY: startButtonY,

                                border: 'none'
                            }} disabled={!enableOk}
                                    onClick={() => {
                                        this.props.setAmountForAutoplay(this.props.transitionBalance);
                                        this.props.hideAutoplay();
                                        this.props.setAutoplay(selectedAutoplayCount);
                                        this.props.setApplicationAutoplayCount(selectedAutoplayCount);
                                        this.props.startAutoplay();
                                        this.props.getApplicationSpinResponse();
                                        this.props.stopWinPresentation();
                                        this.props.resetReelState();
                                        this.props.setAllButtonDisable();
                                        this.reset();
                                    }}
                            ><span className={"startButtonText"} style={{
                                color: 'white',
                            }}>{this.props.langObj["autoplayText_22"]}</span></button>
                        </td>
                    </tr>
                </MDBTableBody>
            </MDBTable>
        )
    }


    //this method will show autoplay for desktop
    desktopViewAutoplay() {

        return (<></>)
    }


    render() {
        if (!this.props.showAutoplay) {
            return (<></>)
        }

        if (isMobile) {
            this.showFixedPanelPage = true;
        }

        return (
            <div style={{height: '100%'}}>
                {!this.showFixedPanelPage && <div style={{height: '100%'}}>
                    {this.desktopViewAutoplay()}
                </div>}
                {this.showFixedPanelPage && <div>
                    {this.mobileViewAutoplay()}
                </div>}
            </div>
        )
    }
}


export default withPixiApp(connect(
    (state: Pick<IStore, 'autoplayState' | 'applicationState' | 'basegameState'|'behaviourState'>): IStateToProps =>
        ({
            showAutoplay: state.autoplayState.showAutoplay,
            scaleY: state.applicationState.scaleY,
            resetAutoplay: state.autoplayState.resetAutoplay,
            balance: state.basegameState.balance,
            currentBetIndex: state.basegameState.currentBetIndex,
            betList: state.basegameState.betList,
            stopAutoplayOnAnyWin: state.autoplayState.stopAutoplayOnAnyWin,
            transitionBalance: state.behaviourState.transitionBalance,

        }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setAllButtonEnable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonEnable(exceptBtnList)),
        hideAutoplay: (): any => dispatch(autoplayActions.hideAutoplayUI()),
        setAutoplay: (autoplayCount: number): any => dispatch(autoplayActions.setAutoplayCount(autoplayCount)),
        startAutoplay: (): any => dispatch(baseGameActions.startAutoplay()),
        setApplicationAutoplayCount: (autoplaycount: number): any => dispatch(baseGameActions.setApplicationAutoplayCount(autoplaycount)),
        getApplicationSpinResponse: (): any => dispatch(asyncActions.getApplicationSpinResponse()),
        setAllButtonDisable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonDisable(exceptBtnList)),
        setValueOfNumberButton: (numberButtonValue: number): any => dispatch(autoplayActions.setValueOfNumberButton(numberButtonValue)),
        interactivityOfStartButton: (startButtonInteractivity: boolean): any => dispatch(autoplayActions.interactivityOfStartButton(startButtonInteractivity)),
        stoppedAutoplayOnWin: (): any => dispatch(autoplayActions.stoppedAutoplayOnWin()),
        setCashIncreasedBy: (value: any): any => dispatch(autoplayActions.setCashIncreasedBy(value)),
        setBalanceIncreasedBy: (value: any): any => dispatch(autoplayActions.setBalanceIncreasedBy(value)),
        setBalanceDecreasedBy: (value: any): any => dispatch(autoplayActions.setBalanceDecreasedBy(value)),
        setSingleWinExceed: (value: any): any => dispatch(autoplayActions.setSingleWinExceed(value)),
        stopWinPresentation: (): any => dispatch(winPresentationAction.stopWinPresentation()),
        resetReelState: (): any => dispatch(Number(configGame["SPIN_TYPE"]) === 0 && reelsActions.resetReelState() || Number(configGame["SPIN_TYPE"]) === 1 && gridsActions.resetReelState() || Number(configGame["SPIN_TYPE"]) === 2 && reelGridActions.resetReelState()),
        setAmountForAutoplay: (storeAmountForAutoplay: any): any => dispatch(behaviourAction.setAmountForAutoplay(storeAmountForAutoplay)),

    }))(withAutoplayConfiguration(AutoplayGenericUI)));